/**
 * TODO: remove after footnotes are added to Headline component
 * @param {string=} content - headline content
 * @param {number=} footnote - footnote number to be added
 * @returns {string} HTMl content for the headline
 */
export const formatHeadlineContent = (content?: string, footnote?: number) => {
    return footnote
        ? `${content}<sup class="ws10-footnote-link-style">${footnote}</sup>`
        : content;
};
